import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Import components
import './App.css';
import Appointment from './components/Appointment';
import UserDetail from './components/UserDetail';
import AuthenticatePartner from './components/AuthenticatePartner';
import RazorpayPayment from './components/RazorpayPayment';
import AppointmentDetail from './components/AppointmentDetail';
import AppointmentConfirm from './components/AppointmentConfirm';

function App() {
  // Check if user is authenticated
  const isAuthenticated = () => {
    return localStorage.getItem('access_token') !== null;
  };

  // Protected route component
  const ProtectedRoute = ({ element }) => {
    return isAuthenticated() ? element : <Navigate to="/" />;
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Default route redirects to appointment without hardcoded parameter */}
          {/* <Route path="/" element={<Appointment />}  /> */}
          
          {/* Redirect root (/) → /book_appointment */}
          <Route path="/" element={<Navigate to="/book_appointment" replace />} />

          {/* Main Appointment page */}
          <Route path="/book_appointment" element={<Appointment />} />
          
          {/* Auth page */}
          <Route path="/auth" element={<AuthenticatePartner />} />
          
          {/* Protected routes */}
          <Route 
            path="/book_appointment/user_detail" 
            element={<ProtectedRoute element={<UserDetail />} />} 
          />
          <Route 
            path="/book_appointment/payment" 
            element={<ProtectedRoute element={<RazorpayPayment/>} />} 
          />
          <Route 
            path="/book_appointment/details" 
            element={<ProtectedRoute element={<AppointmentDetail/>} />} 
          />
          <Route path="/book_appointment/appointment_confirmation" element={<AppointmentConfirm/>} />
          
          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<Navigate to="/book_appointment" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;